import { render, staticRenderFns } from "./PaymentTypeLabel.vue?vue&type=template&id=5e57ea00&scoped=true"
import script from "./PaymentTypeLabel.vue?vue&type=script&lang=ts"
export * from "./PaymentTypeLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e57ea00",
  null
  
)

export default component.exports